/*
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by Rahul Bagaria <Rahul@wakencode.com>, 6 2023
 *
 */

/**
 *  @description This file is used to create a store for the application.
 *               It is used to combine all the reducers and create a store.
 *               It also uses redux-persist to persist the data in the local storage.
 *               It also uses redux-toolkit to create a store.
 *               It also uses redux-thunk to handle the async actions.
 */

import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
} from "redux-persist";

import {  
  imageReducer,
} from "../../controller";

import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "community",
  storage,
  whitelist: [""],
};

const reducers = combineReducers({  
  image: imageReducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
